import { render, staticRenderFns } from "./SequentialListElementSettings.vue?vue&type=template&id=b09a7986&scoped=true&"
import script from "./SequentialListElementSettings.vue?vue&type=script&lang=ts&"
export * from "./SequentialListElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09a7986",
  null
  
)

export default component.exports